import React from 'react';
import { ModalContent } from 'fronton-react';
import { List, ListItem, ModalHeader, Typography } from 'common/components';
import {
  newKitchenHeaderModalContent,
  newKitchenHeaderModalList,
  newKitchenHeaderModalText,
  newKitchenHeaderModalTitle,
} from '../../new-kitchen-header-styles';

export const Delivery = () => (
  <>
    <ModalHeader className={newKitchenHeaderModalTitle} title="Через 10&nbsp;дней новая кухня у&nbsp;вас дома*" />
    <ModalContent className={newKitchenHeaderModalContent}>
      <Typography className={newKitchenHeaderModalText} variant="m" size="body_long">
        Оставьте заявку и&nbsp;уже через 10&nbsp;дней вы&nbsp;сможете пользоваться новой кухней у&nbsp;себя
        дома. Время доставки может незначительно корректироваться в&nbsp;зависимости от&nbsp;региона.
        Позаботимся о&nbsp;всех этапах:
      </Typography>
      <List listStyle="disc" className={newKitchenHeaderModalList}>
        <ListItem>
          <Typography as="span" variant="m" size="body_long">
            компенсируем стоимость замера и&nbsp;подготовим дизайн-проект;
          </Typography>
        </ListItem>
        <ListItem>
          <Typography as="span" variant="m" size="body_long">
            доставим заказ в&nbsp;удобный для вас день и&nbsp;время;
          </Typography>
        </ListItem>
        <ListItem>
          <Typography as="span" variant="m" size="body_long">
            соберём кухню и&nbsp;установим технику.
          </Typography>
        </ListItem>
      </List>
      <Typography variant="m" size="body_long">
        Не&nbsp;является офертой.
      </Typography>
    </ModalContent>
  </>
);
